import React from 'react';
import { PropTypes } from 'prop-types';

const PromotionGroupDetail = props => (
  <div className='mt-5'>
    <div dangerouslySetInnerHTML={{ __html: props.description }}></div>
  </div>
);

PromotionGroupDetail.propTypes = {
  description: PropTypes.string,
};

export default PromotionGroupDetail;



// WEBPACK FOOTER //
// ./src/Promotion/PromotionGroupDetail.js